/**
 * Cookie banner behaviour, kept in an asset so it is fetched once and cached
 * rather than re-sent inside every page.
 */
(function () {
    var root = document.getElementById('bq-cc');
    if (!root) return;

    var views = {
      banner: root.querySelector('[data-bq-cc-view="banner"]'),
      prefs: root.querySelector('[data-bq-cc-view="prefs"]')
    };
    var labelledby = { banner: 'bq-cc-title', prefs: 'bq-cc-title-2' };
    var describedby = { banner: 'bq-cc-desc', prefs: 'bq-cc-desc-2' };
    var toggles = {
      analytics: document.getElementById('bq-cc-tg-analytics'),
      marketing: document.getElementById('bq-cc-tg-marketing'),
      preferences: document.getElementById('bq-cc-tg-preferences')
    };
    var currentView = 'banner';
    var lastFocus = null;
    var openedDeliberately = false;

    function customerPrivacy() {
      return (window.Shopify && window.Shopify.customerPrivacy) || null;
    }

    /* Consent expires after 13 months (CNIL); a choice stored without a
       timestamp predates the rule and counts as expired. */
    var CHOICE_TTL = 13 * 30 * 24 * 3600 * 1000;

    function hasLocalChoice() {
      try {
        var saved = JSON.parse(localStorage.getItem('bq_cookie_consent') || 'null');
        return !!saved && typeof saved.ts === 'number' && Date.now() - saved.ts < CHOICE_TTL;
      } catch (e) { return false; }
    }

    function showView(name) {
      currentView = (name === 'prefs') ? 'prefs' : 'banner';
      views.banner.hidden = currentView !== 'banner';
      views.prefs.hidden = currentView !== 'prefs';
      root.setAttribute('aria-labelledby', labelledby[currentView]);
      root.setAttribute('aria-describedby', describedby[currentView]);
    }

    function isOn(el) {
      return !!el && el.getAttribute('aria-checked') === 'true';
    }
    function setSwitch(el, on) {
      if (el) el.setAttribute('aria-checked', on ? 'true' : 'false');
    }

    function prefillToggles() {
      var consent = {};
      var cp = customerPrivacy();
      try {
        if (cp && typeof cp.currentVisitorConsent === 'function') {
          consent = cp.currentVisitorConsent() || {};
        }
      } catch (e) {}
      /* Fallback: if the API returns nothing (preview, propagation delay),
         prefill from the last local choice. */
      var local = {};
      try { local = JSON.parse(localStorage.getItem('bq_cookie_consent')) || {}; } catch (e) {}
      function on(key) {
        if (consent[key] === 'yes') return true;
        if (consent[key] === 'no') return false;
        return local[key] === true;
      }
      setSwitch(toggles.analytics, on('analytics'));
      setSwitch(toggles.marketing, on('marketing'));
      setSwitch(toggles.preferences, on('preferences'));
    }

    /* Non-modal: no overlay, no scroll lock, no focus trap. Focus moves only on
       a deliberate open (footer link or preview), never stolen on page
       arrival. */
    function open(view, deliberate) {
      openedDeliberately = !!deliberate;
      lastFocus = deliberate ? document.activeElement : null;
      prefillToggles();
      showView(view);
      root.classList.add('bq-cc--open');
      root.setAttribute('aria-hidden', 'false');
      if (deliberate) {
        window.setTimeout(function () {
          try { views[currentView].focus(); } catch (e) {}
        }, 90);
      }
    }

    function close() {
      root.classList.remove('bq-cc--open');
      root.setAttribute('aria-hidden', 'true');
      if (openedDeliberately && lastFocus && lastFocus.focus) {
        try { lastFocus.focus(); } catch (e) {}
      }
      openedDeliberately = false;
    }

    /* Escape: closes the card only if a choice already exists (reopened from the
       footer). First visit: the card stays, non-blocking anyway, and an explicit
       choice is required. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!root.classList.contains('bq-cc--open')) return;
      if (hasLocalChoice()) close();
    });

    function applyConsent(consent) {
      var cp = customerPrivacy();
      if (cp && typeof cp.setTrackingConsent === 'function') {
        try { cp.setTrackingConsent(consent, function () {}); } catch (e) {}
      }
      try {
        /* ts stays out of the object handed to the consent API. */
        var saved = { ts: Date.now() };
        for (var key in consent) { if (consent.hasOwnProperty(key)) saved[key] = consent[key]; }
        localStorage.setItem('bq_cookie_consent', JSON.stringify(saved));
      } catch (e) {}
      close();
    }

    function setAll(granted) {
      applyConsent({ analytics: granted, marketing: granted, preferences: granted });
    }

    function savePreferences() {
      applyConsent({
        analytics: isOn(toggles.analytics),
        marketing: isOn(toggles.marketing),
        preferences: isOn(toggles.preferences)
      });
    }

    function bind(id, handler) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', handler);
    }
    bind('bq-cc-accept', function () { setAll(true); });
    bind('bq-cc-reject', function () { setAll(false); });
    bind('bq-cc-reject-2', function () { setAll(false); });
    bind('bq-cc-save', savePreferences);

    [toggles.preferences, toggles.analytics, toggles.marketing].forEach(function (sw) {
      if (!sw) return;
      sw.addEventListener('click', function () {
        setSwitch(sw, !isOn(sw));
      });
    });

    root.addEventListener('click', function (e) {
      var target = e.target && e.target.closest && e.target.closest('[data-bq-cc-to]');
      if (!target) return;
      e.preventDefault();
      var name = target.getAttribute('data-bq-cc-to');
      showView(name);
      try { views[currentView].focus(); } catch (err) {}
    });

    function decide() {
      if (window.location.search.indexOf('bq-cookies=preview') !== -1) {
        open('banner', true);
        return;
      }
      /* Choice already made locally: don't show again. */
      if (hasLocalChoice()) return;
      var cp = customerPrivacy();
      if (cp && typeof cp.shouldShowBanner === 'function') {
        try {
          if (cp.shouldShowBanner()) {
            /* Gentle entrance: the page settles first, then the card slides in. */
            window.setTimeout(function () { open('banner', false); }, 900);
          }
        } catch (e) {}
      }
    }

    function ready() {
      if (customerPrivacy()) {
        decide();
        return;
      }
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () { decide(); }
        );
        return;
      }
      var tries = 0;
      var interval = window.setInterval(function () {
        tries++;
        if (window.Shopify && (window.Shopify.customerPrivacy || window.Shopify.loadFeatures)) {
          window.clearInterval(interval);
          ready();
        } else if (tries > 24) {
          window.clearInterval(interval);
          decide();
        }
      }, 250);
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('[data-bq-cookie-open]');
      if (!trigger) return;
      e.preventDefault();
      open(trigger.getAttribute('data-bq-cookie-open') === 'prefs' ? 'prefs' : 'banner', true);
    });

    window.BotaQiCookies = {
      open: function () { open('banner', true); },
      openPreferences: function () { open('prefs', true); },
      accept: function () { setAll(true); },
      reject: function () { setAll(false); }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ready);
    } else {
      ready();
    }
  })();
